// Editable table row of group mappings. This sends change events upward.

import * as React from 'react';
import { useTranslation } from 'react-i18next';
import { ComboboxOption, TableCell, TableRow } from '@bb-ui/react-library';
import { FoundationsGroup, GroupMappings } from './GroupMapping.types';
import { Combobox } from 'components/Combobox/Combobox';

export interface GroupMappingEditableTableRowProps extends GroupMappings {
  onChange: (fndsGroup: FoundationsGroup, tenantGroups: string[]) => void;
}

export const GroupMappingEditableTableRow: React.FunctionComponent<
  GroupMappingEditableTableRowProps
> = ({ fndsGroup, mappings, onChange }) => {
  const { t } = useTranslation();

  function onComboboxChange(values: ComboboxOption[]) {
    onChange(
      fndsGroup,
      (values || []).map((item) => item.label as string),
    );
  }

  return (
    <TableRow data-testid={`group-mapping-row-${fndsGroup.name}-${fndsGroup.type}`}>
      <TableCell data-testid="group-mapping-fnds-group-name">{fndsGroup.name}</TableCell>
      <TableCell data-testid="group-mapping-fnds-group-type">{fndsGroup.type}</TableCell>
      <TableCell data-testid="group-mapping-tenant-groups">
        <Combobox
          id={`picker-${fndsGroup.name}`}
          defaultValue={mappings.map(({ idpGroupName }) => ({
            value: idpGroupName!,
            label: idpGroupName!,
          }))}
          floatingLabel
          isMulti
          label={t('tenantIdp.groupPickerLabel')}
          onChange={onComboboxChange}
          placeholder={t('tenantIdp.groupPickerLabel')}
        />
      </TableCell>
    </TableRow>
  );
};
